module.exports = __webpack_public_path__ + "static/media/TeacherWoman.3a9b37dd.svg";